<template>
  <v-app>
    <the-header />

    <router-view v-slot="{ Component }">
      <transition name="route" mode="out-in">
        <component :is="Component" :key="$route.fullPath" />
      </transition>
    </router-view>

    <GlobalDialog
      v-model="dialogState.visible"
      :title="dialogState.title"
      :message="dialogState.message"
      :alert-only="dialogState.alertOnly"
      @ok="dialogState.onConfirm && dialogState.onConfirm()"
      @cancel="dialogState.onCancel && dialogState.onCancel()"
    />

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      location="top right"
    >
      {{ snackbar.text }}
      <template #actions>
        <v-btn icon @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed } from 'vue'
import TheHeader from './components/layout/TheHeader.vue'
import GlobalDialog from './pages/common/GlobalDialog.vue'
import { useDialog } from '@/composables/useDialog'

const loopError = 'ResizeObserver loop completed with undelivered notifications'
const _error = console.error
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes(loopError)) return
  _error(...args)
}

const { dialogState } = useDialog()
const store = useStore()
const snackbar = computed(() => store.state.snackbar)

// Automatically restore user login state on app load
store.dispatch('autoLogin')
</script>